const pageNameKey = "ourNodeAncestorsLineageTree";

export const ourNodeAncestorsLineageTreeEn = {
  [pageNameKey]: { noAncestors: "No Ancestors" },
};

export const ourNodeAncestorsLineageTreePtBr = {
  [pageNameKey]: { noAncestors: "Sem ancestrais" },
};

export const ourNodeAncestorsLineageTreeDe = {
  [pageNameKey]: {
    noAncestors: "Keine Vorfahren",
  },
};

export const ourNodeAncestorsLineageTreeZhHans = {
  [pageNameKey]: { noAncestors: "没有祖先" },
};

export const ourNodeAncestorsLineageTreeIt = {
  [pageNameKey]: { noAncestors: "Nessun nodo rilevato al livello superiore" },
};

export const ourNodeAncestorsLineageTreeEs = {
  [pageNameKey]: { noAncestors: "Sin antecesores" },
};

export const ourNodeAncestorsLineageTreeNl = {
  [pageNameKey]: {
    noAncestors: "Geen bovenliggende items",
  },
};

export const ourNodeAncestorsLineageTreeTr = {
  [pageNameKey]: {
    noAncestors: "Ata Yok",
  },
};
